import { Agencies } from "./agencies";

export class Produit {
  id: number
  name: string;
  description: string;
  agencyName: Agencies[];
  prix: number;
  imageUrl: string;
  status: string;
  categorie: string;
  categoryList: string[];
  promoTitle: string;
  promoImg: string;
  videoUrlProduit: string;
  nomCommercial: string;
  numCommercial: string;
  emailCommercial: string
  NameAgence: any;
  image_url: any;
}